import React, { Fragment } from "react";
import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import {
  ShieldCheck,
  UserCircle,
  BookOpen,
  PenTool,
  Lock,
  AlertTriangle,
  XCircle,
  RefreshCw,
  MessageCircle,
} from "lucide-react";

const TermsPage = () => {
  return (
    <Fragment>
      <Header />

      <main className="kks-dark-wrapper">
        <div className="kks-contact-container">
          <div className="kks-main-card">
            {/* Header */}
            <div className="kks-header-section">
             <h3 style={{ color: "#ffffffff",fontSize: "40px" }}>Terms & Conditions</h3>
               <p>Welcome to our Arts & Music Learning Platform. Please read our guidelines carefully.</p>
             </div>

            <div className="kks-terms-list">
              {/* 1 */}
              <div className="kks-terms-block">
                <div className="kks-terms-header">
                  <div className="kks-icon-box" style={{ background: "rgba(255, 77, 136, 0.1)" }}>
                    <ShieldCheck size={24} color="#ff4d88" />
                  </div>
                  <h2 style={{ color: "#ff4d88" }}>1. Introduction</h2>
                </div>
                <p>
                  Kalakakshaaha is an online learning
                  platform that connects Students with Tutors / Institutes for
                  online and offline classes. By accessing or using the Platform,
                  you agree to be bound by these Terms & Conditions. If you do not
                  agree, please do not use the Platform.
                </p>
              </div>

              {/* 2 */}
              <div className="kks-terms-block">
                <div className="kks-terms-header">
                  <div className="kks-icon-box" style={{ background: "rgba(255, 136, 77, 0.1)" }}>
                    <UserCircle size={24} color="#ff884d" />
                  </div>
                  <h2 style={{ color: "#ff884d" }}>2. Definitions</h2>
                </div>
                <ul>
                  <li><strong>Member:</strong> Any registered user on Kalakakshaaha</li>
                  <li><strong>Student:</strong> A member who registers to learn</li>
                  <li><strong>Tutor / Provider:</strong> A member who registers to teach</li>
                  <li><strong>Platform:</strong> Kalakakshaaha website and services</li>
                  <li><strong>Services:</strong> Listings, discovery, communication, payments, and class facilitation</li>
                </ul>
              </div>

              {/* 3 */}
              <div className="kks-terms-block">
                <div className="kks-terms-header">
                  <div className="kks-icon-box" style={{ background: "rgba(77, 166, 255, 0.1)" }}>
                    <BookOpen size={24} color="#4da6ff" />
                  </div>
                  <h2 style={{ color: "#4da6ff" }}>3. Eligibility</h2>
                </div>
                <ul>
                  <li>Users must be 5 years or older</li>
                  <li>Minors may use the Platform only under parent/guardian supervision</li>
                  <li>Tutors must have legal rights and qualifications to teach</li>
                </ul>
              </div>

              {/* 4 */}
              <div className="kks-terms-block">
                <div className="kks-terms-header">
                  <div className="kks-icon-box" style={{ background: "rgba(51, 204, 153, 0.1)" }}>
                    <PenTool size={24} color="#33cc99" />
                  </div>
                  <h2 style={{ color: "#33cc99" }}>4. Role of Kalakakshaaha</h2>
                </div>
                <p>
                  Kalakakshaaha acts only as a technology platform / intermediary.
                  We do not guarantee tutor quality, student behavior, or learning
                  outcomes. Tutors and Students engage at their own discretion
                  and responsibility.
                </p>
              </div>

              {/* 5 */}
              <div className="kks-terms-block">
                <div className="kks-terms-header">
                  <div className="kks-icon-box" style={{ background: "rgba(204, 102, 255, 0.1)" }}>
                    <Lock size={24} color="#cc66ff" />
                  </div>
                  <h2 style={{ color: "#cc66ff" }}>5. User Responsibilities</h2>
                </div>
                <ul>
                  <li>Provide accurate and complete information</li>
                  <li>Maintain confidentiality of account credentials</li>
                  <li>Follow professional and ethical conduct</li>
                  <li>Not misuse the Platform for illegal or harmful activities</li>
                </ul>
              </div>

              {/* 6 */}
              <div className="kks-terms-block">
                <div className="kks-terms-header">
                  <div className="kks-icon-box" style={{ background: "rgba(255, 102, 102, 0.1)" }}>
                    <XCircle size={24} color="#ff6666" />
                  </div>
                  <h2 style={{ color: "#ff6666" }}>6. Tutor Terms</h2>
                </div>
                <ul>
                  <li>Tutors are independent professionals, not employees</li>
                  <li>Fees and schedules are agreed directly with Students</li>
                  <li>Classes must be conducted professionally</li>
                  <li>Disputes with students are tutor responsibility</li>
                </ul>
              </div>

              {/* 7 */}
              <div className="kks-terms-block">
                <div className="kks-terms-header">
                  <div className="kks-icon-box" style={{ background: "rgba(0, 153, 204, 0.1)" }}>
                    <AlertTriangle size={24} color="#0099cc" />
                  </div>
                  <h2 style={{ color: "#0099cc" }}>7. Student Terms</h2>
                </div>
                <ul>
                  <li>Tutor selection is the student’s responsibility</li>
                  <li>Learning outcomes are not guaranteed</li>
                  <li>Payments are subject to platform rules</li>
                  <li>Issues must be raised through official support</li>
                </ul>
              </div>

              {/* 8 */}
              <div className="kks-terms-block">
                <div className="kks-terms-header">
                  <div className="kks-icon-box" style={{ background: "rgba(255, 170, 0, 0.1)" }}>
                    <RefreshCw size={24} color="#ffaa00" />
                  </div>
                  <h2 style={{ color: "#ffaa00" }}>8. Payments & Fees</h2>
                </div>
                <p>
                  Kalakakshaaha may charge platform fees or commissions. All
                  payments must be made through approved methods. Refunds, if
                  applicable, are governed by the platform refund policy.
                </p>
              </div>

              {/* 9 */}
              <div className="kks-terms-block">
                <div className="kks-terms-header">
                  <div className="kks-icon-box" style={{ background: "rgba(255, 51, 170, 0.1)" }}>
                    <MessageCircle size={24} color="#ff33aa" />
                  </div>
                  <h2 style={{ color: "#ff33aa" }}>9. Contact Information</h2>
                </div>
                <p>
                  Kalakakshaaha Support<br />
                  <strong>Email:</strong> Kalakakshaaha@gmail.com<br />
                  
                  
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <style>{`

      @media (max-width: 768px) {
 
.kks-terms-list {
padding: 0px !important;
      }
.kks-terms-block {
padding: 0px !important;
      }
 
      }
        .kks-terms-list {
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .kks-terms-block {
          background: rgba(255, 255, 255, 0.03);
          padding: 25px;
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.05);
          transition: transform 0.3s ease;
          width: 100%;
        }
        .kks-terms-block:hover {
          transform: translateX(10px);
          background: rgba(255, 255, 255, 0.05);
        }
        .kks-terms-header {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 15px;
        }
        .kks-terms-header h2 {
          font-size: 22px;
          margin: 0;
        }
        .kks-terms-block p,
        .kks-terms-block li {
          color: #ccc;
          font-size: 15px;
          line-height: 1.6;
        }
        .kks-terms-block ul {
          padding-left: 20px;
          margin-top: 10px;
        }
      `}</style>

      <Footer />
    </Fragment>
  );
};

export default TermsPage;
